<template>
	<div class="page-users page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">用户列表</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/system/role' }">角色管理</el-breadcrumb-item>
							<el-breadcrumb-item>角色人员列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="userName" align="center" label="姓名" min-width="80">
							</el-table-column>
							<el-table-column prop="mobilePhone" align="center" label="手机号码" min-width="160">
							</el-table-column>
							
							<el-table-column prop="topOrgName" align="center" label="所属顶级组织名称" min-width="80">
							</el-table-column>
							<!-- <el-table-column prop="roleKeys" align="center" label="角色key" min-width="280">
							</el-table-column> -->
							<el-table-column prop="statusText" align="center" label="状态" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.statusText}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="isDeleteText" align="center" label="是否删除" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.isDelete">{{scope.row.isDeleteText}}</span>
								</template>
							</el-table-column>
						
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
			
			<!-- 图片放大 -->
			<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
				<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
			</el-dialog>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				roleId:this.$route.query.roleId == undefined? '' : this.$route.query.roleId,
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				form_search: {
					
				},
				init_data: {
					status_list: [],
					type_list: [],
				},
				is_master_show: false,
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '用户列表';
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				params.roleId=_this.roleId;
				_this.table_data.loading = true;
				
				this.$client.get('/api/sys/role/getListUserByRoleId', params, function(res, message,total,totalPages) {
					_this.table_data.list = res;
					// _this.table_data.page_info = res.pager;
					//_this.table_data.page_info.page = totalPages;
					_this.table_data.page_info.total=total
					_this.is_master_show = res.is_master_show;
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			
			handleSizeChange(val) {
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.table_data.page_info.page = val;
				this.getList();
			},
			
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.balance-title {
		text-align: center;
		font-size: 18px;
		color: #161616;
	}

	.balance-text {
		font-size: 14px;
		color: #161616;
		padding: 20px;
		text-align: center;
		margin-bottom: 20px;
	}

	.balance-text span {
		font-size: 24px;
	}
</style>
